import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoRadioButtonConfig extends IEoFormControlConfig {
  type?: 'radioButton';
  radioButtonStyleClass?: string;
  value?: any;
}

export class EoRadioButtonConfig
  extends EoFormControlConfig
  implements IEoRadioButtonConfig
{
  override type?: 'radioButton';
  radioButtonStyleClass?: string;
  value?: any;

  constructor();
  constructor(obj: IEoRadioButtonConfig);
  constructor(obj?: IEoRadioButtonConfig) {
    super(obj as IEoFormControlConfig);
    this.type = 'radioButton';
    if (obj?.value) this.value = obj.value;
    this.radioButtonStyleClass = obj?.radioButtonStyleClass ?? '';
  }
}
